// Display helpers shared by every ops screen.

// Amounts arrive from the API in MINOR units (kobo). Formatting them in one place
// is what stops a screen quietly showing ₦45,000 as ₦4,500,000.
export function money(minor, currency = 'NGN') {
  const value = Number(minor || 0) / 100;
  try {
    return new Intl.NumberFormat('en-NG', { style: 'currency', currency, maximumFractionDigits: 0 }).format(value);
  } catch (_) {
    return `${currency} ${value.toLocaleString()}`;
  }
}

// Prices are TYPED in major units. Parsing here means the console never posts a
// string where the API expects a number.
export function toMajorInput(minor) {
  if (minor == null) return '';
  return String(Number(minor) / 100);
}

export const STATUS_LABEL = {
  awaiting_deposit: 'Awaiting deposit',
  confirmed: 'Confirmed',
  assigned: 'Team assigned',
  in_progress: 'In progress',
  quality_check: 'Quality check',
  completed: 'Completed',
  cancelled: 'Cancelled',
};

export const QUOTE_STATUS_LABEL = {
  new: 'New',
  consult_scheduled: 'Consultation booked',
  scoped: 'Scoped',
  sent: 'Sent',
  accepted: 'Accepted',
  declined: 'Declined',
  expired: 'Expired',
};

export const FREQUENCY_LABEL = {
  one_off: 'One-off',
  weekly: 'Weekly',
  biweekly: 'Fortnightly',
  monthly: 'Monthly',
};

export function when(date, time) {
  if (!date) return '—';
  return time ? `${date} · ${time}` : date;
}

export function dt(value) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' });
}

export function titleise(s) {
  return String(s || '').replace(/[_-]+/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());
}
